<template>
  <v-menu
    v-model="menu"
    :elevation="0"
    offset-y
    offset-x
    :nudge-left="40"
    :nudge-bottom="12"
    :close-on-content-click="false"
    rounded="lg"
  >
    <template v-slot:activator="{ on, attrs }">
      <div class="ml-n2 mr-2 mt-n4">
        <v-badge bordered color="primary" overlap :content="filter.length" :value="filter.length" bottom v-if="!large">
          <v-btn icon v-bind="attrs" v-on="on" @click="initTempFilter" data-test-filter>
            <v-icon v-if="filter.length" ref="toggleFilter" :color="filter.length ? 'info' : ''"> mdi-filter </v-icon>
            <v-icon v-else ref="toggleFilter"> mdi-filter-outline </v-icon>
          </v-btn>
        </v-badge>
        <span v-else class="ml-n7">
          <v-btn v-bind="attrs" v-on="on" elevation="0" color="info" small @click="initTempFilter">
            <v-badge :content="filter.length || '0'" color="warning">
              <span>
                {{ $t("components.FilterCardPagination.editFilter") }}
              </span>
            </v-badge>
          </v-btn>
        </span>
        <v-divider vertical class="mt-3 mb-n3" style="position: relative; top: -2px" />
      </div>
    </template>
    <v-card
      v-if="menu"
      :elevation="0"
      rounded="lg"
      :style="`width: ${
        $vuetify.breakpoint.smAndDown ? '100vw' : predefinedFilter && predefinedFilter.length ? '650px' : '450px'
      };
        word-break: break-word;
        `"
      class="pa-1"
    >
      <v-row>
        <v-col md="4" cols="12" v-if="predefinedFilter">
          <v-subheader>{{ $t("components.FilterCardPagination.suggestions") }}</v-subheader>
          <v-chip
            class="ma-1"
            v-for="(preFilter, index) in predefinedFilter"
            :key="index"
            small
            @click="setPredefinedFilter(preFilter.filter)"
          >
            {{ $t(preFilter.name) }}
          </v-chip>
        </v-col>
        <v-col :md="mdSizeFilter" cols="12">
          <v-form v-model="isValid" class="mt-6">
            <v-subheader v-if="!tempFilter.length">
              {{ $t(`components.FilterCardPagination.noFilter`) }}
            </v-subheader>
            <div
              v-for="(filter, index) in tempFilter"
              :key="'temp-filter' + index + filter.key"
              style="display: flex; flex-direction: row"
              class="ma-1 my-n4"
            >
              <filter-card-pagination-menu-filter-element
                :value="filter"
                :filterList="filterList"
                @remove="removeItem(index)"
              />
            </div>
            <v-row>
              <v-col cols="12">
                <a text small @click="addFilter" class="info--text ml-1" data-test-filter-add>
                  <small>
                    {{ $t(`components.FilterCardPagination.add`) }}
                  </small>
                </a>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>

      <v-card-actions>
        <v-spacer />
        <v-btn @click="removeAll" small outlined color="info" :disabled="!tempFilter.length">
          {{ $t(`components.FilterCardPagination.removeAll`) }}
        </v-btn>
        <v-btn @click="confirmFilter" small elevation="0" color="info" :disabled="!isValid" data-test-filter-apply>
          {{ $t("confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script lang="ts">
import { PaginationFilterListElement, PaginationFilterOperationEnum } from "@/store/modules/base-pagination.store";
import { Component, Prop, Vue } from "vue-property-decorator";
import FilterCardPaginationMenuFilterElement from "./FilterCardPaginationMenuFilterElement.vue";
import { IPageFilterElement, PageFilterElement } from "@/models/page-filter-element.entity";
import { PredefinedFilterType } from "@/views/event/filter/event.filter";

@Component({
  components: {
    FilterCardPaginationMenuFilterElement
  }
})
export default class FilterCardPagination extends Vue {
  @Prop({ default: [] })
  filterList!: PaginationFilterListElement[];

  @Prop({ default: false })
  large!: boolean;

  @Prop({ default: () => [] })
  filter!: IPageFilterElement[];

  @Prop({ default: () => [] })
  predefinedFilter!: PredefinedFilterType[];

  /**
   * Content on search bar
   */
  @Prop()
  search!: string;

  menu = false;

  isValid = false;

  tempFilter: IPageFilterElement[] = [];

  get mdSizeFilter() {
    if (this.predefinedFilter) {
      return 8;
    }
    return 12;
  }

  get _filter() {
    return this.filter;
  }

  set _filter(filter: IPageFilterElement[]) {
    this.$emit("update:filter", filter);
  }

  get operations() {
    return Object.values(PaginationFilterOperationEnum);
  }

  setPredefinedFilter(filter: IPageFilterElement[]) {
    this.tempFilter.splice(0);
    this.$nextTick(() => {
      this.tempFilter.push(...filter);
      this.confirmFilter();
    });
  }

  removeItem(index: number) {
    this.tempFilter.splice(index, 1);
  }

  addFilter() {
    this.tempFilter.push(new PageFilterElement({ key: "", operation: PaginationFilterOperationEnum.EQUAL, value: "" }));
  }

  confirmFilter() {
    this.filter.splice(0, this.filter.length, ...this.tempFilter);
    this.$emit("confirmFilter");
    this.menu = false;
  }

  removeAll() {
    this.tempFilter.splice(0);
    this._filter.splice(0);
    this.$emit("removeAll");
    this.confirmFilter();
  }

  /**
   *
   */
  initTempFilter() {
    this.tempFilter.splice(0);
    // Copy filter as new object. Otherwise if the value is changed the changes are applied immediately as the reference is the same
    this._filter.forEach((f) => this.tempFilter.push(new PageFilterElement(f)));
  }
}
</script>
<style scoped>
::v-deep .v-badge__badge {
  z-index: 1;
}
</style>
